module.exports = __webpack_public_path__ + "resources/img/img_gamebase_game4.6069b3a46b5d4286cf3ecb2ee40c066c.png";